import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Model } from 'survey-core';
import { Survey } from 'survey-react-ui';
import axios from 'axios';
import Cookies from 'js-cookie';
import 'survey-core/defaultV2.min.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

function PublicSurveyRunner() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [survey, setSurvey] = useState(null);
  const [surveyModel, setSurveyModel] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [userName, setUserName] = useState('');
  const [showNamePrompt, setShowNamePrompt] = useState(true);
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    const storedName = Cookies.get('formAppUserName');
    if (storedName) {
      setUserName(storedName);
      setShowNamePrompt(false);
    }
    
    loadSurvey();
  }, [id]);

  const loadSurvey = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}/surveys/${id}`);
      setSurvey(response.data);
      
      const model = new Model(response.data.json);
      model.showProgressBar = 'top';
      model.progressBarType = 'pages';
      model.onComplete.add(handleSurveyComplete);
      
      setSurveyModel(model);
      setLoading(false);
    } catch (err) {
      setError('Failed to load form: ' + err.message);
      setLoading(false);
    }
  };

  const handleNameSubmit = (e) => {
    e.preventDefault();
    if (userName.trim()) {
      Cookies.set('formAppUserName', userName.trim(), { expires: 30 });
      setShowNamePrompt(false);
    }
  };

  const handleSurveyComplete = async (sender) => {
    try {
      const responses = sender.data;
      const storedName = Cookies.get('formAppUserName');
      
      await axios.post(`${API_URL}/responses`, {
        surveyId: id,
        userName: storedName || 'Anonymous',
        responses: responses
      });
      
      setSubmitted(true);
    } catch (err) {
      alert('Failed to submit form: ' + err.message);
    }
  };

  if (loading) {
    return (
      <div className="public-container">
        <div className="public-header">
          <img src="/Aqlyze-logo.png" alt="Aqlyze" className="public-logo" />
        </div>
        <div className="public-content">
          <div className="loading">Loading Form...</div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="public-container">
        <div className="public-header">
          <img src="/Aqlyze-logo.png" alt="Aqlyze" className="public-logo" />
        </div>
        <div className="public-content">
          <div className="error">{error}</div>
          <button 
            onClick={() => navigate('/public')} 
            className="button"
            style={{ marginTop: '1rem' }}
          >
            ← Back to Form List
          </button>
        </div>
      </div>
    );
  }

  if (showNamePrompt) {
    return (
      <div className="public-container">
        <div className="public-header">
          <img src="/Aqlyze-logo.png" alt="Aqlyze" className="public-logo" />
        </div>
        <div className="public-content">
          <h2 className="public-title">Welcome</h2>
          <p className="public-subtitle">Please enter your name to continue</p>
          
          <form onSubmit={handleNameSubmit}>
            <div className="form-group">
              <label className="form-label">Your Name *</label>
              <input
                type="text"
                className="form-input"
                value={userName}
                onChange={(e) => setUserName(e.target.value)}
                placeholder="Enter your name"
                required
                autoFocus
              />
            </div>
            
            <button type="submit" className="button" style={{ width: '100%' }}>
              Continue to Form
            </button>
          </form>
        </div>
      </div>
    );
  }

  if (submitted) {
    return (
      <div className="public-container">
        <div className="public-header">
          <img src="/Aqlyze-logo.png" alt="Aqlyze" className="public-logo" />
        </div>
        <div className="public-content">
          <div className="success-message">
            <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>✅</div>
            <h2 style={{ marginBottom: '1rem' }}>Thank You!</h2>
            <p>Your response has been submitted successfully.</p>
            <p style={{ marginTop: '0.5rem', color: '#7f8c8d' }}>
              Submitted by: <strong>{Cookies.get('formAppUserName')}</strong>
            </p>
          </div>
          
          <button 
            className="button"
            onClick={() => navigate('/public')}
            style={{ width: '100%', marginTop: '2rem' }}
          >
            ← Back to Form List
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="public-container">
      <div className="public-header">
        <img src="/Aqlyze-logo.png" alt="Aqlyze" className="public-logo" />
      </div>
      
      <div className="public-content">
        <button 
            onClick={() => navigate('/public')}
            className="button button-secondary"
            style={{ marginBottom: '1rem' }}
        >
            ← Back to Form List
        </button>
        <div style={{ marginBottom: '1.5rem' }}>
          <h2 className="public-title">{survey.title}</h2>
          {survey.description && (
            <p className="public-subtitle">{survey.description}</p>
          )}
          <p style={{ color: '#7f8c8d', fontSize: '0.85rem', marginTop: '0.5rem' }}>
            Taking form as: <strong>{Cookies.get('formAppUserName')}</strong>
          </p>
        </div>
        
        {surveyModel && <Survey model={surveyModel} />}
      </div>
    </div>
  );
}

export default PublicSurveyRunner;